import { AxiosResponse } from 'axios';
import { RestaurantArticle, RestaurantData } from '../store/reducers/restaurant/types';

import api, { CreateServiceUrl, ResponsibleFuction } from './api'

const u = CreateServiceUrl('SiteApi')

const login: ResponsibleFuction<any> = (data: FormData) => {
  return api.post(
    u`login/`,
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: '*/*',
      },
    },
  )
}

const register: ResponsibleFuction = (data: FormData) => {
  return api.post(
    u`register/`,
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  )
}

const contactRequest: ResponsibleFuction = (data: FormData) => {
  return api.post(
    u`contactrequest/`,
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  )
}

const resetPassword: ResponsibleFuction = (user: string, key: string, data: FormData) => {
  const url = `${user}/forgotpasswordreset/${key}/`
  return api.post(
    u`${url}`,
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  )
}

const confirmPassword: ResponsibleFuction = (user: string, key: string, data: FormData) => {
  const url = `${user}/forgotpasswordconfirm/${key}/`
  return api.post(
    u`${url}`,
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  )
}

const forgotPassword: ResponsibleFuction = (data: FormData) => {
  return api.post(
    u`forgotpassword/`,
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  )
}

const getRestaurantsByZipCode: ResponsibleFuction = (zipCode: string) => {
  const formData = new FormData()
  formData.append('zipcode', zipCode)

  return api.post(
    u`fetchrestaurantbyzipcode/`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  )
}

const getRestaurantsBySearchTerm: ResponsibleFuction = (searchTerm: string) => {
  const formData = new FormData()
  formData.append('searchterm', searchTerm)

  return api.post(
    u`fetchrestaurantbysearchterm/`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  )
}

const getAllRestaurants: ResponsibleFuction<RestaurantData[]> = () => {
  return api.get(u`fetchallrestaurant/`)
}
const getRestaurant: ResponsibleFuction<RestaurantData[]> = (restid: number) => {
  const formData = new FormData();
  formData.append('restid', `${restid}`);
  return api.post(
    u`fetchrestaurantdetails/`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  )
}

const getOrderDetails: ResponsibleFuction = (orderId: string) => {
  return api.get(u`orderdetails/${orderId}/`)
}

const getArticleRestaurant: ResponsibleFuction<RestaurantArticle[]> = (id: string) => {
  return api.get(
    u`articlesperrestaurant/${id}`,
  )
}

const customerMSQ: ResponsibleFuction = (restId: number) => {
  const formData = new FormData();
  formData.append('restid', `${restId}`);

  return api.post(
    u`customermsg`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  )
}

const getOrderList: ResponsibleFuction = (data: FormData) => {
  return api.post(
    u`orderlist/`,
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  )
}

export {
  login, getAllRestaurants, getRestaurant, resetPassword, forgotPassword, getOrderDetails,
  register, getRestaurantsByZipCode, getArticleRestaurant, customerMSQ, getOrderList,
  confirmPassword, getRestaurantsBySearchTerm, contactRequest
}
